import 'isomorphic-fetch'
import "core-js/stable";
import "regenerator-runtime/runtime";
import { provider } from '@k-ramel/react'
import store from './store'
import App from './app.container'

export default provider(store())(App)
